import * as DatasetHelper from '../dataset-helper';

/**
 * Calculate the worst case {@code Variance} ("var.s(1,0,0...n)") based on the number of categories.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
  const { categories } = categoryField;
  const numOfCategories = categories.length;
  const resultPropertyName = calculationStepDefn.result;

  // Calculate mean.
  const mean = 1.0 / numOfCategories;

  // Calculate variance.
  let varianceAccumulator = (1.0 - mean) ** 2;
  for (let counter = 0; counter < numOfCategories - 1; counter += 1) {
    varianceAccumulator += (0.0 - mean) ** 2;
  }
  const variance = (numOfCategories > 1 ? varianceAccumulator / (numOfCategories - 1) : 0.0);
  statistics[resultPropertyName] = variance;

}



// WEBPACK FOOTER //
// ./src/app/utils/calculators/worst-case-variance-calculator.js